/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultInhibitor } from './ResultInhibitor';
import {
    ResultInhibitorFromJSON,
    ResultInhibitorFromJSONTyped,
    ResultInhibitorToJSON,
    ResultInhibitorToJSONTyped,
} from './ResultInhibitor';
import type { ChainResidues } from './ChainResidues';
import {
    ChainResiduesFromJSON,
    ChainResiduesFromJSONTyped,
    ChainResiduesToJSON,
    ChainResiduesToJSONTyped,
} from './ChainResidues';
import type { Mutation } from './Mutation';
import {
    MutationFromJSON,
    MutationFromJSONTyped,
    MutationToJSON,
    MutationToJSONTyped,
} from './Mutation';

/**
 * 
 * @export
 * @interface ViewerAnnotations
 */
export interface ViewerAnnotations {
    /**
     * 
     * @type {string}
     * @memberof ViewerAnnotations
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerAnnotations
     */
    domainType: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerAnnotations
     */
    proteinCode: string;
    /**
     * 
     * @type {Array<ChainResidues>}
     * @memberof ViewerAnnotations
     */
    essentialResidues: Array<ChainResidues>;
    /**
     * 
     * @type {Mutation}
     * @memberof ViewerAnnotations
     */
    mutation: Mutation;
    /**
     * 
     * @type {Array<ChainResidues>}
     * @memberof ViewerAnnotations
     */
    mutatedPdbPositions?: Array<ChainResidues>;
    /**
     * 
     * @type {{ [key: string]: Array<ChainResidues>; }}
     * @memberof ViewerAnnotations
     */
    pocketMap?: { [key: string]: Array<ChainResidues>; };
    /**
     * 
     * @type {Array<ResultInhibitor>}
     * @memberof ViewerAnnotations
     */
    inhibitors?: Array<ResultInhibitor>;
}

/**
 * Check if a given object implements the ViewerAnnotations interface.
 */
export function instanceOfViewerAnnotations(value: object): value is ViewerAnnotations {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('domainType' in value) || value['domainType'] === undefined) return false;
    if (!('proteinCode' in value) || value['proteinCode'] === undefined) return false;
    if (!('essentialResidues' in value) || value['essentialResidues'] === undefined) return false;
    if (!('mutation' in value) || value['mutation'] === undefined) return false;
    return true;
}

export function ViewerAnnotationsFromJSON(json: any): ViewerAnnotations {
    return ViewerAnnotationsFromJSONTyped(json, false);
}

export function ViewerAnnotationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewerAnnotations {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'domainType': json['domainType'],
        'proteinCode': json['proteinCode'],
        'essentialResidues': ((json['essentialResidues'] as Array<any>).map(ChainResiduesFromJSON)),
        'mutation': MutationFromJSON(json['mutation']),
        'mutatedPdbPositions': json['mutatedPdbPositions'] == null ? undefined : ((json['mutatedPdbPositions'] as Array<any>).map(ChainResiduesFromJSON)),
        'pocketMap': json['pocketMap'] == null ? undefined : json['pocketMap'],
        'inhibitors': json['inhibitors'] == null ? undefined : ((json['inhibitors'] as Array<any>).map(ResultInhibitorFromJSON)),
    };
}

export function ViewerAnnotationsToJSON(json: any): ViewerAnnotations {
    return ViewerAnnotationsToJSONTyped(json, false);
}

export function ViewerAnnotationsToJSONTyped(value?: ViewerAnnotations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'domainType': value['domainType'],
        'proteinCode': value['proteinCode'],
        'essentialResidues': ((value['essentialResidues'] as Array<any>).map(ChainResiduesToJSON)),
        'mutation': MutationToJSON(value['mutation']),
        'mutatedPdbPositions': value['mutatedPdbPositions'] == null ? undefined : ((value['mutatedPdbPositions'] as Array<any>).map(ChainResiduesToJSON)),
        'pocketMap': value['pocketMap'],
        'inhibitors': value['inhibitors'] == null ? undefined : ((value['inhibitors'] as Array<any>).map(ResultInhibitorToJSON)),
    };
}

